(function (c, h, i, m, p) {
    m = c.createElement(h);
    p = c.getElementsByTagName(h)[0];
    m.async = true; // Changed from 1 to true
    m.src = i;
    p.parentNode.insertBefore(m, p);
})(document, 'script', 'https://chimpstatic.com/mcjs-connected/js/users/6a78f4e94872e2a330b64d6c9/87f45bdfb013acf66b554ea08.js');